<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
  <rect x="0.5" y="7.7" width="16" height="1.6" rx="0.5" fill="#E5E5E5"/>
  <rect x="2" y="3.5" width="1.5" height="10" rx="0.5" fill="#E5E5E5"/>
  <rect x="3.8" y="4.5" width="1.2" height="8" rx="0.5" fill="#E5E5E5"/>
  <rect x="5.2" y="7" width="0.8" height="3" rx="0.3" fill="#E5E5E5"/>
  <rect x="11" y="7" width="0.8" height="3" rx="0.3" fill="#E5E5E5"/>
  <rect x="12" y="4.5" width="1.2" height="8" rx="0.5" fill="#E5E5E5"/>
  <rect x="13.5" y="3.5" width="1.5" height="10" rx="0.5" fill="#E5E5E5"/>
</svg>
